import { useFloorPlanConfiguration } from 'floorplan/pages/floorplan/hooks/use-floorplan-configuration.hook';

export default function useHasFloorPlan() {
  return Boolean(useFloorPlanConfiguration());
}
